import { render, staticRenderFns } from "./ProcessNewBookAndchapter.vue?vue&type=template&id=2163a95e&scoped=true"
import script from "./ProcessNewBookAndchapter.vue?vue&type=script&lang=js"
export * from "./ProcessNewBookAndchapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163a95e",
  null
  
)

export default component.exports